import * as React from 'react';
import { connect } from 'react-redux';

import CreateAccountForm from '../../components/createAccountForm';
import { CreateAccountFormValues } from '../../components/createAccountForm/createAccountForm';
import { UserService } from '../../services/userService';
import history from '../../services/history';
import * as Edge from '../../core';
import CardRegisterWrapper from './cardRegisterWrapper';
import { login } from '../../store/login/actions';
import ScrollToTopOnMount from '../../components/global/scrollToTopOnMount';
import BlockRegistration from '../../components/redirectExternal/blockRegistration';
import { CheckoutProps } from '../checkout/models';

export interface Page1Props extends CheckoutProps {
	login: (command: Edge.Models.LoginUserCommand) => Promise<void>;
}

export class Page1 extends React.Component<Page1Props> {
	public render() {
		if (!this.props.model.price) {
			return <BlockRegistration />;
		}
		return (
			<CardRegisterWrapper
				{...this.props}
				allowEdit={this.props.model.price.price.priceType !== Edge.Models.PriceTypes.Recurring}
			>
				<ScrollToTopOnMount />
				<CreateAccountForm
					onSubmit={this.createAccount}
					includeOrganizationFields
					showRecurringSubscriptionFields={
						this.props.model.price.price.priceType === Edge.Models.PriceTypes.Recurring
					}
					{...(this.props.model.price.price.priceType === Edge.Models.PriceTypes.Recurring
						? {
								productRenewalMonths: this.props.model.price.price.months,
						  }
						: {})}
				/>
			</CardRegisterWrapper>
		);
	}
	private createAccount = async (values: CreateAccountFormValues) => {
		const userExists = await UserService.userExists(values.username!);
		if (userExists) {
			throw new Error(Edge.Constants.USER_EXISTS_ERROR_MESSAGE);
		}
		const result = await UserService.createUserAndOrganization(
			Object.assign({
				agreedToCookiesAtRegistration: values.agreedToCookiesAtRegistration!,
				agreedToLicenseAgreementAtRegistration: values.agreedToLicenseAgreementAtRegistration!,
				email: values.email!,
				firstName: values.firstName!,
				isIndividual: values.isIndividual!,
				lastName: values.lastName!,
				levelId: values.levelId!,
				organizationName: values.organizationName!,
				organizationTypeId: values.organizationTypeId!,
				password: values.password!,
				positionId: values.positionId,
				recaptchaConfirmation: values.recaptchaConfirmation!,
				sportId: values.sportId!,
				username: values.username!,
				wasAtLeast13YearsOldAtRegistration: values.wasAtLeast13YearsOldAtRegistration!,
			})
		);
		await this.props.onChange({
			email: values.email,
			userFullName: `${values.firstName} ${values.lastName}`,
			organizationId: result.organizationId,
			sport: result.sport,
			userId: result.userId,
		});
		await this.props.login({
			username: values.username!,
			password: values.password!,
		});

		// if we have a SKU, proceed immediately to purchase process
		if (this.props.model.price) {
			history.push(`/register/page-2`);
		} else {
			history.push(`/`);
		}
	};
}

export default connect(
	undefined,
	{
		login,
	}
)(Page1);
